import { Typography } from '@mui/material';
import type { RaRecord } from 'react-admin';
import { dateTimeNoSeconds } from '../../shared/dateTime';

/**
 * Okno czasu: oba krańce, albo sam początek („od …”). Prezlecenie zna jedną
 * datę na punkt i drugiego krańca nie zgadujemy — wcześniej wychodziło
 * „— – —” (e2e na dev, 28.09.2026).
 */
export function windowText(from?: string | null, to?: string | null): string {
  if (!from && !to) return '—';
  if (from && !to) return `od ${dateTimeNoSeconds(from)}`;
  if (!from && to) return `do ${dateTimeNoSeconds(to)}`;
  return `${dateTimeNoSeconds(from)} – ${dateTimeNoSeconds(to)}`;
}

/**
 * Klient z prezlecenia, gdy wiersz nie ma kontrahenta z kartoteki.
 *
 * Bank nie ma kolumny na nazwę klienta, a kontrahenta po nazwie nie
 * dowiązujemy („Trans-Sped” ↔ „TRANS SPED Sp. z o.o.” to zgadywanie). Nazwa
 * z prezlecenia jest więc podpisana jako taka — nie udaje wiersza kartoteki.
 */
export const ClientFromPreOrder = ({ record }: { record: RaRecord }) => {
  const name = (record.preOrder as RaRecord | undefined)?.clientName as string | undefined;
  if (!name) return <>—</>;
  return (
    <>
      —{' '}
      <Typography component="span" variant="body2" color="text.secondary">
        (klient z prezlecenia: {name}, niepowiązany z kartoteką kontrahentów)
      </Typography>
    </>
  );
};

